import { axiosInstance } from 'api/instance';
import { ProductCategoriesResponse } from 'api/Products/types';
import urls from 'api/Products/urls';

import { AxiosResponse } from 'axios';

export const getProductCategoriesRequest = ({ signal }: AbortController): Promise<AxiosResponse<ProductCategoriesResponse>> => {
  return axiosInstance.get<ProductCategoriesResponse>(urls.productCategoriesUrl, { signal });
};
